import type { RouteRecordRaw, Router } from 'vue-router'

const BuyContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/rent',
  name: 'RentEstateModulePages',
  children: [
    {
      path: '',
      name: 'RentEstateMainRoute',
      component: () => import('./views/RentView.vue'),
      meta: {
        title: 'rentEstate.rentContract',
      },
    },
    {
      path: 'create',
      name: 'RentEstateCreateRoute',
      component: () => import('./views/RentUpsertView.vue'),
      meta: {
        title: 'rentEstate.createViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:rentEstateId',
      name: 'RentEstateEditRoute',
      component: () => import('./views/RentUpsertView.vue'),
      meta: {
        title: 'rentEstate.editViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'renew/:rentEstateId',
      name: 'RentEstateRenewRoute',
      component: () => import('./views/RentUpsertView.vue'),
      meta: {
        title: 'renewContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:rentEstateId',
      name: 'ViewRentEstateRoute',
      component: () => import('./views/SingleRentView.vue'),
      meta: {
        title: 'rentEstate.singleViewTitle',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BuyContractRoutes)
}
